import { FixedSizeList } from 'react-window';
import UmbrellaConceptsList from './UmbrellaConceptsList';
const VirtualisedUMCListComponent = ({ data, currentSelected, handleCurrentSelected, handleTag, handleChecked, isChecked, loadConcepts }) => {
  return (
    <FixedSizeList
      height={500} // Set the height of the visible area 
      itemCount={data.length}
      itemSize={30} // Set the height of each individual item 
      width='auto' // Set the width of the visible area 
    >
      {({ index, style }) => (
        <UmbrellaConceptsList
          concept={data[index]}
          style={style}
          handleChecked={handleChecked}
          isChecked={isChecked}
          loadConcepts={loadConcepts}
          currentSelected={currentSelected}
          handleCurrentSelected={handleCurrentSelected}
          handleTag={handleTag}
        />
      )}
    </FixedSizeList>
  );
}

export default VirtualisedUMCListComponent;